module.exports = __webpack_public_path__ + "img/headshot-nan-young-kim@2x.d2239d93.jpg";